import React from 'react';
import { useState } from 'react';
// @ts-ignore
import styles from './RequestPayment.module.scss';
import SubmitButton from '../Button/SubmitButton';
import AddButton from '../Button/AddButton';
import apiClient from '../../Services/ApiClient';
import { useAppContext } from '../../Services/AppContext';
import * as yup from 'yup';
import OverlayLoading from '../OverlayLoading';
import useTranslation from '../../Hooks/useTranslation';
import FormattedPriceInputField from '../../Modules/Base/Components/Inputs/FormattedPriceInput/FormattedPriceInputField';
import InputField from '../Form/components/InputField';
import FormWrapper from '../Form/FormWrapper';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useInputValidation } from '../../Modules/Base/Hooks/useInputValidation';
import { getFormattedPriceAsFloat } from '../../Modules/Base/Services/priceFormat.service';

interface RequestPaymentProps {
	caseId: string;
	onSuccess?: () => void;
}

export default function RequestPayment(props: RequestPaymentProps) {
	const { caseId, onSuccess } = props;
	const { currency, vatRate } = useAppContext();
	const [processing, setProcessing] = useState(false);
	const { t } = useTranslation();
	const { getPriceInputValidation } = useInputValidation();
	// @ts-ignore
	const handleRequestPayment = async values => {
		setProcessing(true);
		const result = await apiClient.post(`/case/${caseId}/order`, {
			orderItems: [
				{
					name: values.label,
					price: {
						pricePieceWithVat: getFormattedPriceAsFloat(values.price),
						currency: currency,
						vatRate: vatRate,
					},
				},
			],
		});
		setProcessing(false);
		onSuccess && onSuccess();
	};

	const handleAddItem = () => {};

	const validationSchema = yup.object({
		label: yup.string().required(t('base.itemName')),
		price: getPriceInputValidation('base.price', true),
	});

	const formMethods = useForm({
		defaultValues: {},
		resolver: yupResolver(validationSchema),
	});

	return (
		<div style={{ position: 'relative' }}>
			<FormWrapper formMethods={formMethods}>
				<div className={styles.wrapper}>
					<div className={'row'}>
						<div className={'col-lg-8 col-12'}>
							<InputField name='label' label='base.itemName' isRequired />
						</div>
						<div className={'col-lg-4 col-12'}>
							<FormattedPriceInputField
								name='price'
								label='base.price'
								isRequired
							/>
						</div>
					</div>
					{false && (
						<div className={'mt-2'}>
							<AddButton onClick={handleAddItem} />
						</div>
					)}
				</div>
				<SubmitButton
					onSubmit={handleRequestPayment}
					title={'base.shared.confirm'}
				/>
			</FormWrapper>
			{processing && <OverlayLoading />}
		</div>
	);
}
